import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { siteConfig } from "../data/site";
import { db } from "../lib/data";
import { supabase } from "../lib/supabase";
export function AboutPage() {
  return (
    <section className="content-page">
      <div className="page-title">
        <span>About KIZAK</span>
        <h1>Comfort, engineered.</h1>
        <p>
          KIZAK builds airflow and electrical products around practical
          performance, dependable engineering and everyday use.
        </p>
      </div>
    </section>
  );
}
export function ContactPage() {
  const [ok, setOk] = useState(false),
    [form, setForm] = useState({
      name: "",
      email: "",
      phone: "",
      product: "",
      description: "",
    });
  const submit = async (e) => {
    e.preventDefault();
    const { error } = await supabase.from("enquiries").insert(form);
    if (error) throw error;
    setOk(true);
  };
  if (ok)
    return (
      <section className="content-page">
        <div className="page-title">
          <span>Thank you</span>
          <h1>Enquiry received.</h1>
          <p>KIZAK will follow up using the contact details provided.</p>
        </div>
      </section>
    );
  return (
    <section className="content-page">
      <div className="page-title">
        <span>Contact Us</span>
        <h1>Let's talk.</h1>
      </div>
      <div className="contact-grid">
        <div>
          <span className="eyebrow">Get in touch</span>
          <h2>Tell us what you are looking for.</h2>
          <p>
            {siteConfig.phone}
            <br />
            {siteConfig.email}
          </p>
        </div>
        <form onSubmit={submit}>
          {[
            ["name", "Full Name"],
            ["email", "Email Address"],
            ["phone", "Phone"],
            ["product", "Product / Model"],
          ].map(([k, l]) => (
            <label key={k}>
              {l}
              <input
                required={k === "name" || k === "email"}
                type={k === "email" ? "email" : "text"}
                value={form[k]}
                onChange={(e) => setForm({ ...form, [k]: e.target.value })}
              />
            </label>
          ))}
          <label>
            Description
            <textarea
              required
              rows="6"
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
            />
          </label>
          <button className="outline-btn">
            SUBMIT <ArrowUpRight size={16} />
          </button>
        </form>
      </div>
    </section>
  );
}
export function CollectionPage({ slug }) {
  const [c, setC] = useState(null),
    [p, setP] = useState([]);
  useEffect(() => {
    db.categories().then((x) => {
      const a = x.find((v) => v.slug === slug);
      setC(a);
      if (a) db.products({ category: a.id }).then(setP);
    });
  }, [slug]);
  if (!c)
    return (
      <section className="content-page">
        <h1>Collection</h1>
      </section>
    );
  return (
    <section className="content-page">
      <div className="page-title">
        <span>Collection</span>
        <h1>{c.name}</h1>
        <p>{c.description}</p>
      </div>
      <div className="shop-grid">
        {p.map((x) => (
          <div key={x.id}>
            <Link to={`/shop/${x.slug}`}>
              <b>{x.display_name || x.name}</b>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
export function LegalPage({ title }) {
  return (
    <section className="content-page">
      <div className="page-title">
        <span>Legal</span>
        <h1>{title}</h1>
      </div>
      <p>Publish the approved KIZAK legal content through the admin CMS.</p>
    </section>
  );
}
export function NotFoundPage() {
  return (
    <section className="content-page">
      <h1>Page not found.</h1>
    </section>
  );
}
